import { render, staticRenderFns } from "./WorkoutSplitEdit.vue?vue&type=template&id=280d79c7&scoped=true"
import script from "./WorkoutSplitEdit.vue?vue&type=script&lang=js"
export * from "./WorkoutSplitEdit.vue?vue&type=script&lang=js"
import style0 from "./WorkoutSplitEdit.vue?vue&type=style&index=0&id=280d79c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280d79c7",
  null
  
)

export default component.exports